
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IDatePlace } from 'src/app/models/location.model';
import { DateService } from 'src/app/services/date/date.service';

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'date-place-selector',
  templateUrl: 'date-place-selector.component.html',
  styleUrls: ['./date-place-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: DatePlaceSelectorComponent
    },
    {
        provide: NG_VALIDATORS, 
        useExisting: forwardRef(() => DatePlaceSelectorComponent),
        multi: true,
    },
]
})
export class DatePlaceSelectorComponent implements OnInit {
  form: UntypedFormGroup = this.formBuilder.group({
    geocoding: [null, Validators.required],
    date: [null, Validators.compose([Validators.required])],
    fromTimeHour: [],
    toTimeHour: [],
    moment: [],
  });;

  local:string = "fr-fr";
  month:string;
  @Input()
  minDate:string;
  @Input()
  maxDate:string;
  @Input()
  deliveryType:string;
  @Input()
  favoritePlaces:Geolocation[];
  @Input()
  locationTypes:[]
  @Input()
  dayValues:string;
  @Input()
  title:string;
  day:string;  
  year:string;
  dayName: string;
  dateStrLocal:string;
  showPicker = false;
  onChange = (value) => {};
  onTouched = () => {};
  onChangeSubs: Subscription[] = [];
  onValidationChange: any = () => {};
  // @Input()
  // value:string | any ;

  @Input()
  value:IDatePlace ;

  _datePlace: IDatePlace;

  touched = false;
  @Input()
  disabled = false;

  minAddDate: string;
  maxAddDate: string;
  addDatesValues:string;

  @Output() valueChanged = new EventEmitter<IDatePlace>();

  deliveryTypesWithTiming = ["market", "collectpoint", "ownshop", "pickupstore", "picking"];


  constructor(private dateService:DateService, private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(){
  }

  setForm(){
    // this.form = this.formBuilder.group({
    //   geocoding: [null, Validators.required],
    //   date: [null, Validators.compose([Validators.required])],
    //   fromTimeHour: [],
    //   toTimeHour: [],
    //   moment: [],
    // });
    this.form.patchValue(this.value);
  }

  ngOnDestroy() {
    for (let sub of this.onChangeSubs) {
      sub.unsubscribe();
    }
  }

  registerOnChange(onChange: any) {
      // console.log('register on change', onChange,this.form.value);
    const sub = this.form.valueChanges.subscribe(onChange);
    this._datePlace = this.form.value;
    this.onChangeSubs.push(sub);
    // this.onChange = onChange;
  }
  setDisabledState(disabled: boolean) {
    if (disabled) {
      this.form.disable();
    }
    else {
      this.form.enable();
    }
  }

  writeValue(value: IDatePlace) {
    if(value){
      this.form.setValue(value, {emitEvent: false});
      this._datePlace = {...value};
    }
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  validate(control: AbstractControl): ValidationErrors {
    if (this.form.valid) {
      return null;
    }

    let errors : any = {};

    errors = this.addControlErrors(errors, "geocoding");
    errors = this.addControlErrors(errors, "moment");
    errors = this.addControlErrors(errors, "date");
    errors = this.addControlErrors(errors, "fromTimeHour");
    errors = this.addControlErrors(errors, "toTimeHour");

    return errors;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  inputValidator(): ValidatorFn  {
      return (control:AbstractControl) : ValidationErrors | null => {
          if(!this.value){
              return {label:{value:false}}
          }
          else {
              return null
          }
      };
  }

  onDateChange(date){
    this._datePlace.date = date;
    this.showPicker = false;
    this.propagateChange();
  }

  onGeocodingFromChange(geocoding){
    this._datePlace.geocoding = geocoding;
    this.propagateChange();
  }

  onTimeFromChange(fromTimeHour){
    this._datePlace.fromTimeHour = this.dateService.cleanTime(fromTimeHour);
    this.propagateChange();
  }

  onTimeToChange(toTimeHour){
    this._datePlace.toTimeHour = this.dateService.cleanTime(toTimeHour);
    this.propagateChange();
  }

  propagateChange(){
    // this.markAsTouched();
    // this.onChange(this._datePlace);
    // this.onValidationChange();
    // this.valueChanged.emit(this._datePlace); 
  }
  addControlErrors(allErrors: any, controlName:string) {

    const errors = {...allErrors};

    const controlErrors = this.form.controls[controlName].errors;

    if (controlErrors) {
      errors[controlName] = controlErrors;
    }

    return errors;
  }
}
